interface KCLogoProps {
  className?: string;
  size?: number;
}

/**
 * Playce Academy logo — full brand mark (child leaping over obstacle).
 * Used in nav/header and prominent placements.
 * Note: component name kept as KCLogo to avoid churn across imports.
 */
export function KCLogo({ className = '', size = 40 }: KCLogoProps) {
  return (
    <img
      src="/playce-logo.png"
      alt="Playce Academy"
      className={`object-contain ${className}`}
      style={{ width: 'auto', height: size }}
    />
  );
}

/**
 * Compact icon-only version (child only) — for small/square placements.
 */
export function KCLogoIcon({ className = '', size = 24 }: KCLogoProps) {
  return (
    <img
      src="/playce-icon.png"
      alt="Playce Academy"
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
